import cx from "classnames";
import { type UrlObject } from "url";
import Link from "next/link";

import { Label } from "common/ui/Label";

import styles from "./ActionList.module.scss";

interface Props {
  menu: ({
    name: string | number,
    disabled?: boolean
  } & (
    {
      href: string | UrlObject,
      onClick?: undefined,
    } | {
      href?: undefined,
      onClick: () => void,
    }
  ))[],
  close?: () => void,
  className?: string,
}

export function ActionList({ menu, close, className }: Props) {
  return (
    <div className={cx(styles.ActionList, className)}>
      {menu.map((i, idx) => {
        if (i.href) {
          return (
            <Link
              key={`${i.name}-${idx}`}
              href={i.href}
              className={cx(styles.Button, {
                [styles.disabled]: i.disabled,
              })}
              onClick={(e) => {
                e.stopPropagation();
                close && close();
              }}
            >
              <Label variant="l1">{i.name}</Label>
            </Link>
          )
        } else {
          return (
            <button
              key={`${i.name}-${idx}`}
              className={styles.Button}
              disabled={i.disabled}
              onClick={(e) => {
                e.stopPropagation();
                i.onClick && i.onClick();
                close && close();
              }}
            >
              <Label variant="l1">{i.name}</Label>
            </button>
          )
        }
      })}
    </div>
  )
}

